module.exports = __webpack_public_path__ + "img/logo-family.65113b07.png";